import React from "react";
import DashboardShellBase from "../../pages/SHARED/components/DashboardShellBase";

const PGDashboard = (props) => <DashboardShellBase {...props} variant="pg" />;

export default PGDashboard;
